import { FullscreenDialogHeader } from "./FullscreenDialogHeader";
import { FullscreenDialogContent } from "./FullscreenDialogContent";

import { Dialog, DialogContent } from "@/components/ui/dialog";
import { MediaFullscreenDialog } from "@/components/ui/MediaBlocks";
import { ReportCell, ReportColumn } from "@/types/evaluate";

interface CellFullscreenDialogProps {
  isOpen: boolean;
  onClose: () => void;
  cell: ReportCell | null;
  column: ReportColumn | null;
  viewMode?: "normal" | "raw";
}

function getOutputMediaUrl(cell: ReportCell | null): string | null {
  if (!cell?.display_value) {
    return null;
  }
  const dv = cell.display_value;
  const raw = dv.value as { type?: string; url?: string; media_type?: string } | undefined;
  if (dv.type === "output_media" && raw?.url) {
    return raw.url;
  }
  if (raw?.type === "output_media" && raw?.url) {
    return raw.url;
  }
  return null;
}

export const CellFullscreenDialog = ({
  isOpen,
  onClose,
  cell,
  column,
  viewMode = "normal",
}: CellFullscreenDialogProps) => {
  const mediaUrl = getOutputMediaUrl(cell);

  if (mediaUrl && viewMode !== "raw") {
    return (
      <MediaFullscreenDialog
        isOpen={isOpen}
        onClose={onClose}
        title="Generated image"
        downloadUrl={mediaUrl}
        downloadFilename="generated-image"
        variant="dark"
        modal={false}
        preventOutsideDismiss
      >
        <div className="flex flex-1 items-center justify-center p-6">
          <img src={mediaUrl} alt="Generated" className="max-h-[75vh] max-w-full object-contain" />
        </div>
      </MediaFullscreenDialog>
    );
  }

  return (
    <Dialog open={isOpen} onOpenChange={onClose} modal={false}>
      <DialogContent
        className="fixed inset-0 flex h-screen w-screen max-w-none translate-x-0 translate-y-0 flex-col rounded-none border-0 p-0 shadow-none"
        shouldShowCloseButton={false}
        onPointerDownOutside={e => e.preventDefault()}
        onInteractOutside={e => e.preventDefault()}
      >
        {cell && column ? (
          <>
            <FullscreenDialogHeader column={column} onClose={onClose} viewMode={viewMode} />
            <FullscreenDialogContent cell={cell} column={column} viewMode={viewMode} />
          </>
        ) : (
          <div className="flex h-full items-center justify-center">
            <span className="text-gray-500">Loading...</span>
          </div>
        )}
      </DialogContent>
    </Dialog>
  );
};
